module.exports = __webpack_public_path__ + "img/objects-align-top.12402ad3.svg";